import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayoutService } from '@app/shared/components/layout/layout.service';
import { ToastService } from '@teorema/patron';
import { User } from 'src/app/models';
import { TicketNotificationsService } from 'src/app/services/ticket-notifications.service';
import { SortPipe } from 'src/app/shared/pipes';
import {
  AgentTicketService,
  TcCurrentLogService,
  TcTicketLogService,
  TcTicketService,
  UserService,
  UtilsService,
} from 'src/app/shared/services';
import { TicketDropService } from '../services/ticket-drop.service';
import { AbstractSprintComponent } from './abstract-sprint/abstract-sprint.component';
import { SprintColumnComponent, SprintOpenedChange } from './sprint-column/sprint-column.component';

@Component({
  selector: 'app-sprint',
  templateUrl: './sprint.component.html',
  styleUrls: ['./sprint.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SprintComponent extends AbstractSprintComponent {
  user?: User;
  @ViewChildren(SprintColumnComponent) sprintColumnComponents!: QueryList<SprintColumnComponent>;
  @ViewChild('kanbanContainer') kanbanContainer!: ElementRef;
  //SprintBeta
  isBeta = false;

  constructor(
    protected override tcTicketService: TcTicketService,
    protected override toastService: ToastService,
    protected override datePipe: DatePipe,
    protected override sortPipe: SortPipe,
    protected override layoutService: LayoutService,
    protected override userService: UserService,
    protected override utilsService: UtilsService,
    protected override tcTicketLogService: TcTicketLogService,
    protected override currentTicketLogService: TcCurrentLogService,
    public ticketDropService: TicketDropService,
    protected override agentTicketService: AgentTicketService,
    protected override ticketNotificationsService: TicketNotificationsService,
    private route: ActivatedRoute
  ) {
    super(
      tcTicketService,
      toastService,
      datePipe,
      sortPipe,
      layoutService,
      userService,
      utilsService,
      tcTicketLogService,
      currentTicketLogService,
      agentTicketService,
      ticketNotificationsService
    );
    this.getScreenSize();
  }

  override async ngOnInit() {
    //SprintBeta
    this.isBeta = this.route.snapshot.data['beta'] ?? false;
    super.ngOnInit();
    this.openCurrentUserSprints();
    this.loadMinimizedSprints();
  }

  async openCurrentUserSprints() {
    this.user = await this.userService.getCurrentUser().catch(e => {
      console.error(e);
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });

    let dev = 'Sem Desenvolvedor';
    if (this.user?.name) {
      dev = this.user.name;
    }

    // Immutable update
    // Immutable update
    this.sprintStateService.update({ activeDeveloper: dev }); // Init service state
  }

  override handleTickets() {
    this._handleTickets('Sem Desenvolvedor');
  }

  override addTaskToSprint(sprint, task, ticketTask) {
    this._addTaskToSprint(sprint, task, ticketTask, task.user?.name, 'Sem Desenvolvedor');
  }

  drop(event: any) {
    this.ticketDropService.drop(event, this);
  }

  trackByKey(index: number, key: string): string {
    return key;
  }
}
